module.exports = __webpack_public_path__ + "static/media/teletava3.49fe49af.png";